module.exports = __webpack_public_path__ + "img/android.d6ef9e99.svg";